import { render, staticRenderFns } from "./AlternateGSRPQualifierList2.vue?vue&type=template&id=865112fc&scoped=true&"
import script from "./AlternateGSRPQualifierList2.vue?vue&type=script&lang=ts&"
export * from "./AlternateGSRPQualifierList2.vue?vue&type=script&lang=ts&"
import style0 from "./AlternateGSRPQualifierList2.vue?vue&type=style&index=0&id=865112fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865112fc",
  null
  
)

export default component.exports